(function () {
/**
 * Cookie Consent Banner
 * GDPR-compliant consent management for analytics
 */ const $4f641905d8ab17c3$var$CONSENT_KEY = "cookie_consent";
const $4f641905d8ab17c3$var$CONSENT_VERSION = "1"; // Increment if privacy policy changes significantly
function $4f641905d8ab17c3$export$f99197f0d0633d5e() {
    const consent = localStorage.getItem($4f641905d8ab17c3$var$CONSENT_KEY);
    if (!consent) return null;
    try {
        const parsed = JSON.parse(consent);
        // Check if consent version matches
        if (parsed.version !== $4f641905d8ab17c3$var$CONSENT_VERSION) return null;
        return parsed.accepted;
    } catch  {
        return null;
    }
}
function $4f641905d8ab17c3$export$24a32d9eaac5e08d(accepted) {
    localStorage.setItem($4f641905d8ab17c3$var$CONSENT_KEY, JSON.stringify({
        accepted: accepted,
        version: $4f641905d8ab17c3$var$CONSENT_VERSION,
        timestamp: new Date().toISOString()
    }));
}
function $4f641905d8ab17c3$export$aa2e2863d5778f13() {
    const consent = $4f641905d8ab17c3$export$f99197f0d0633d5e();
    // If consent already given, don't show banner
    if (consent !== null) return;
    // Create and show banner
    const banner = $4f641905d8ab17c3$var$createBanner();
    document.body.appendChild(banner);
    // Animate in
    requestAnimationFrame(()=>{
        banner.classList.add("visible");
    });
}
/**
 * Create the consent banner element
 */ function $4f641905d8ab17c3$var$createBanner() {
    const banner = document.createElement("div");
    banner.id = "cookieConsentBanner";
    banner.className = "cookie-consent-banner";
    banner.setAttribute("role", "dialog");
    banner.setAttribute("aria-label", "Cookie consent");
    banner.innerHTML = `
    <div class="cookie-consent-content">
      <p>
        Vi bruker Firebase for \xe5 lagre kj\xf8leskapsdataene dine og kan bruke analyseverkt\xf8y for \xe5 forbedre appen.
        <a href="privacy.html" target="_blank">Les v\xe5r personvernerkl\xe6ring</a>
      </p>
      <div class="cookie-consent-buttons">
        <button type="button" id="cookieAccept" class="cookie-btn cookie-btn-accept">
          Godta
        </button>
        <button type="button" id="cookieDecline" class="cookie-btn cookie-btn-decline">
          Bare n\xf8dvendige
        </button>
      </div>
    </div>
  `;
    // Add event listeners
    banner.querySelector("#cookieAccept").addEventListener("click", ()=>{
        $4f641905d8ab17c3$export$24a32d9eaac5e08d(true);
        $4f641905d8ab17c3$var$hideBanner(banner);
    // Here you could initialize analytics if user accepts
    // initAnalytics();
    });
    banner.querySelector("#cookieDecline").addEventListener("click", ()=>{
        $4f641905d8ab17c3$export$24a32d9eaac5e08d(false);
        $4f641905d8ab17c3$var$hideBanner(banner);
    });
    return banner;
}
/**
 * Hide and remove the banner
 */ function $4f641905d8ab17c3$var$hideBanner(banner) {
    banner.classList.remove("visible");
    banner.addEventListener("transitionend", ()=>{
        banner.remove();
    }, {
        once: true
    });
}
// Auto-initialize when DOM is ready
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $4f641905d8ab17c3$export$aa2e2863d5778f13);
else $4f641905d8ab17c3$export$aa2e2863d5778f13();

})();
//# sourceMappingURL=index.103a6b67.js.map
